// extracted by mini-css-extract-plugin
export default {"underBanner":"ForYou_underBanner__hsh1E","content":"ForYou_content__8n2dD","text":"ForYou_text__Cf5Tz","image":"ForYou_image__MslWG"};